(function () {
  'use strict';

  /* global vfleetsConstants */

  angular
    .module('enumModule')
    .constant('RolesEnum', vfleetsConstants.v3gRoles);
}());
